import { graphql } from '@apollo/react-hoc';
import { gql } from 'graphql-tag';

export const query = gql`
  query GetList($id: Int!) {
    getList(id: $id) {
      name
      recipients {
        id
        cellphone
        data {
          key
          value
        }
      }
    }
  }
`;

export default graphql(query, {
  options: ({ match: { params } }) => {
    const currentList = Number(params.id);
    return {
      variables: { id: currentList ? currentList : 0 },
      fetchPolicy: 'cache-and-network',
    };
  },
});
